(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const menuButton = document.querySelector('[data-menu]');
  const menu = document.getElementById('mf-mobile-nav');
  function setMenu(open) {
    if (!menuButton || !menu) return;
    menu.hidden = !open;
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  menuButton?.addEventListener('click', () => setMenu(menu.hidden));
  menu?.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape' && menu && !menu.hidden) {setMenu(false); menuButton.focus();} });
  document.addEventListener('click', e => {if (menu && !menu.hidden && !e.target.closest('.site-header')) setMenu(false);});
  matchMedia('(min-width: 961px)').addEventListener('change', e => {if(e.matches) setMenu(false);});
  // Floating app launchers otherwise cover the narrow-screen purchase button.
  // Keep their widgets and navigation available, but give the purchase form clear space.
  const purchaseForms = document.querySelectorAll('[data-mf-product-form], [data-mf-cart-form], [data-mf-quick-order]');
  if(purchaseForms.length && 'IntersectionObserver' in window) {
    const visiblePurchaseForms = new Set();
    const purchaseObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visiblePurchaseForms.add(entry.target);
        else visiblePurchaseForms.delete(entry.target);
      });
      document.body.classList.toggle('mf-purchase-in-view', visiblePurchaseForms.size > 0);
    });
    purchaseForms.forEach(form => purchaseObserver.observe(form));
  }

  // A restored page keeps disabled form state. Reset completed quick orders only;
  // a request still in flight must stay locked and must never be replayed here.
  const completedQuickOrders = new WeakSet();
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-mf-quick-order]').forEach(form => {
      if (!completedQuickOrders.has(form) || form.dataset.busy !== 'true') return;
      completedQuickOrders.delete(form);
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-mf-quick-status]');
      if (button) button.disabled = false;
      if (status) status.textContent = '';
    });
  });

  // Our AJAX handlers own these forms. Cancel during capture so Shopify skips
  // its form-intent event; the successful Cart API response supplies the event.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement &&
        form.matches('[data-mf-product-form], [data-mf-quick-order]')) {
      event.preventDefault();
    }
  }, true);

  // First-purchase cards always add one-time items. Existing Appstle product
  // forms keep their own selling-plan handling below.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-mf-quick-order]')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-mf-quick-status]');
    const cartForm = document.querySelector('[data-mf-cart-form]');
    if (cartForm && form.closest('.mf-cart-complement') &&
        [...cartForm.querySelectorAll('input[name="updates[]"]:not(:disabled):not([readonly])')].some(input => input.value !== input.defaultValue)) {
      status.textContent = 'Update your bag before adding another flavor.';
      cartForm.querySelector('[name="update"]')?.focus();
      return;
    }
    const fields = new FormData(form);
    const items = [];
    if (fields.has('id')) items.push({id: fields.get('id'), quantity: Number(fields.get('quantity') || 1)});
    else for (let i=0; fields.has('items['+i+'][id]'); i++) {
      items.push({id: fields.get('items['+i+'][id]'), quantity: Number(fields.get('items['+i+'][quantity]') || 1)});
    }
    if (!items.length || items.some(item => !/^\d+$/.test(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1)) return;
    completedQuickOrders.delete(form);
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy','true');
    button.disabled = true;
    status.textContent = 'Adding to your bag…';
    try {
      const response = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This selection could not be added.');
      status.textContent = 'Added. Opening your bag…';
      completedQuickOrders.add(form);
      window.location.assign(root+'cart');
    } catch (error) {
      completedQuickOrders.delete(form);
      status.textContent = (error.message && !(error instanceof TypeError) ? error.message+' ' : '')+'Check your bag before trying again.';
      const link=document.createElement('a'); link.href=root+'cart'; link.textContent='View bag'; status.append(link);
      status.tabIndex=-1; status.focus(); button.disabled=false;
      form.dataset.busy='false'; form.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-mf-product-form]')) return;
    e.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const submit = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-mf-form-status]');
    const data = new FormData(form);
    // Appstle can insert a second hidden selling_plan input. Read our selected
    // native option explicitly, then normalize FormData to one authoritative value.
    const selectedPlan = form.querySelector('[data-mf-plans] input[name="selling_plan"]:checked');
    if (selectedPlan?.value) data.set('selling_plan', selectedPlan.value);
    else data.delete('selling_plan');
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy','true');
    if(submit) submit.disabled = true;
    if(status) status.textContent = 'Adding to your bag…';
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', body:data, headers:{Accept:'application/json'}});
      const result = await response.json();
      if(!response.ok) throw new Error(result.description || result.message || 'We could not add this item. Please try again.');
      if(status) status.textContent = 'Added. Opening your bag…';
      window.location.assign(root + 'cart');
    } catch(error) {
      if(status) {status.textContent = error.message || 'We could not connect. Please try again.'; status.setAttribute('tabindex','-1'); status.focus();}
      if(submit) submit.disabled = false;
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
    }
  });
  // Keep native cart posts and existing app validation. This storefront check
  // covers the canister group; it does not replace a checkout-side business rule.
  const cart = document.querySelector('[data-mf-cart-form]');
  document.addEventListener('ajaxProduct:added', () => window.location.assign(root + 'cart'));
  const minimum = cart?.querySelector('[data-mf-canister-minimum]');
  const checkout = cart?.querySelector('[name="checkout"]');
  function updateCanisterMinimum() {
    if (!cart || !minimum) return true;
    const count = [...cart.querySelectorAll('[data-mf-wholesale-canister]')]
      .reduce((total, input) => total + (Number(input.value) || 0), 0);
    const valid = count === 0 || count >= 2;
    minimum.hidden = count === 0;
    minimum.dataset.invalid = String(!valid);
    minimum.querySelector('[data-mf-canister-message]').textContent = valid
      ? 'Wholesale canisters: minimum 2 total, mix and match Chai and Vanilla.'
      : 'Add one more wholesale canister to check out, or remove the canister. Minimum: 2 total, mix and match Chai and Vanilla.';
    if (checkout) {
      checkout.disabled = !valid;
      if (!valid) checkout.setAttribute('aria-describedby', minimum.id);
      else checkout.removeAttribute('aria-describedby');
    }
    return valid;
  }
  cart?.addEventListener('input', updateCanisterMinimum);
  updateCanisterMinimum();
  cart?.addEventListener('submit', e => {
    if (e.submitter?.name !== 'update' && !updateCanisterMinimum()) {
      e.preventDefault();
      minimum.focus();
      return;
    }
    const status = cart.querySelector('[data-mf-cart-status]');
    if(status) status.textContent = 'Updating your order…';
  });
})();
